import '../app/App.css';

import { Link } from 'react-router-dom';

function Footer() {
    return (
        <div style={{marginTop: "10%"}}>
            <Link to="/terms-and-services" className="footer-text footer-brown" style={{textDecoration: 'none'}}>
                Terms and Conditions<br/>
            </Link>
            <Link to="/privacy-policy" className="footer-text footer-brown" style={{textDecoration: 'none'}}>
                Privacy Policy
            </Link>
            <p className="footer-text">
                foodscape inc DBA bobaface<br />3517 Hill Street SE Apt 347. Albany, OR, 97322<br />thebobaface@gmail.com
            </p>
        </div>
    )
}

export default Footer;